import { useTranslation } from "react-i18next";
import styles from "./SectionHeader.module.scss";

export const SectionHeader = ({
  title,
  showViewAll = false,
  onViewAll,
  titleVariant = "default",
}: {
  title: string;
  showViewAll?: boolean;
  onViewAll?: () => void;
  titleVariant?: "default" | "compact";
}) => {
  const { t } = useTranslation("selflearn");

  return (
    <div className={styles.sectionHeader}>
      <h2
        className={
          titleVariant === "compact"
            ? styles.sectionTitleCompact
            : styles.sectionTitle
        }
      >
        {title}
      </h2>
      {showViewAll && (
        <button className={styles.viewAllLink} onClick={onViewAll}>
          {t("revise.topicSummary.viewAll")}
        </button>
      )}
    </div>
  );
};
